import { render } from "./InputCoinAmount.vue?vue&type=template&id=0ceaf336&scoped=true"
import script from "./InputCoinAmount.vue?vue&type=script&lang=js"
export * from "./InputCoinAmount.vue?vue&type=script&lang=js"

import "./InputCoinAmount.vue?vue&type=style&index=0&id=0ceaf336&scoped=true&lang=scss"
import "./InputCoinAmount.vue?vue&type=style&index=1&id=0ceaf336&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceaf336"]])

export default __exports__